module.exports = __webpack_public_path__ + "static/media/search.698ee69a.svg";